import CopyTradingView from "./CopyTradingView";

export default CopyTradingView;
